import {
    List,
    Create,
    Edit,
    SimpleForm,
    TextInput,
    TextField,
    EditButton,
    DateField,
    Resource,
    ReferenceField,
    ReferenceInput,
    SelectInput,
    Show,
    Filter,
    Datagrid,
    FunctionField} from "react-admin";
import { validateNumericInput } from "../utils/validators/validate-numeric";
import { toPercentage } from "../utils/utils";

  const Filters = (props) => (
    <Filter {...props}>
      <TextInput label="Search by article" source="article.name" alwaysOn />
      <TextInput label="Search by packaging" source="retailPackaging.name" alwaysOn />
      <ReferenceInput label="Project" source="projectId" reference="projects" perPage={500} alwaysOn>
        <SelectInput optionText="name" />
      </ReferenceInput>
    </Filter>
  );

  const ArticlePackagingList = (props) => {
    return (
      <List {...props} filters={Filters(props)}>
        <div style={{marginTop: '15px'}}>
          <Datagrid rowClick="show">
            <TextField label="Article" source="article.name" />
            <TextField label="Packaging name" source="retailPackaging.name" />
            <FunctionField
                source="share"
                render={record => toPercentage(record)}
            />
            <ReferenceField label="Type (online/offline)" source="retailGroupId" reference="retailGroup" link={false}>
              <TextField source="name" />
            </ReferenceField>
            <ReferenceField label="Project" source="projectId" reference="projects" link={false}>
              <TextField source="name" />
            </ReferenceField>
            <DateField source="createdAt" label="Creation date" />
            <DateField source="updatedAt" label="Update date" />
            <EditButton />
          </Datagrid>
        </div>
      </List>
    );
  };

  const ShowArticlePackaging = (props) => {
    return (
      <Show {...props}>
        <SimpleForm>
            <TextField label="Article" source="article.name" />
            <TextField label="Packaging name" source="retailPackaging.name" />
            <FunctionField
                source="share"
                render={record => toPercentage(record)}
            />
            <ReferenceField label="Type (online/offline)" source="retailGroupId" reference="retailGroup" link={false}>
              <TextField source="name" />
            </ReferenceField>
            <ReferenceField label="Project" source="projectId" reference="projects" link={false}>
              <TextField source="name" />
            </ReferenceField>
            <DateField source="createdAt" label="Creation date" />
            <DateField source="updatedAt" label="Update date" />
          <EditButton />
        </SimpleForm>
      </Show>
    );
  };

  const CreateArticlePackaging = (props) => {
    return (
      <Create {...props}>
        <SimpleForm>
          <ReferenceInput label="Article" source="articleId" reference="articles">
            <SelectInput optionText="name" required={true} />
          </ReferenceInput>
          <ReferenceInput label="Packaging name" source="retailPackagingId" reference="retailPackaging">
            <SelectInput optionText="name" required={true} />
          </ReferenceInput>
          <TextInput source="share" validate={validateNumericInput} />
          <ReferenceInput label="Type (online/offline)" source="retailGroupId" reference="retailGroup">
            <SelectInput optionText="name" required={true} />
          </ReferenceInput>
          <ReferenceInput label="Project" source="projectId" reference="projects">
            <SelectInput optionText="name" required={true} />
          </ReferenceInput>
        </SimpleForm>
      </Create>
    );
  };

  const EditArticlePackaging = (props) => {
    return (
      <Edit {...props}>
        <SimpleForm>
            <ReferenceInput label="Article" source="articleId" reference="articles">
                <SelectInput optionText="name" required={true} />
            </ReferenceInput>
            <ReferenceInput label="Packaging name" source="retailPackagingId" reference="retailPackaging">
                <SelectInput optionText="name" required={true} />
            </ReferenceInput>
            <TextInput source="share" validate={validateNumericInput} />
            <ReferenceInput label="Type (online/offline)" source="retailGroupId" reference="retailGroup">
                <SelectInput optionText="name" required={true} />
            </ReferenceInput>
            <ReferenceInput label="Project" source="projectId" reference="projects">
                <SelectInput optionText="name" required={true} />
            </ReferenceInput>
        </SimpleForm>
      </Edit>
    );
  };



  const articlePackagingResource = () => <Resource
    name="articlePackaging"
    options={{ label: 'Article packaging', menuGroup: 'Articles'}}
    list={ArticlePackagingList}
    create={CreateArticlePackaging}
    edit={EditArticlePackaging}
    show={ShowArticlePackaging} />;

  export default articlePackagingResource;
